import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useSiteContent } from "../../context/SiteContext";

const NAV = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/producers-suite", label: "Producer's Suite", testid: "nav-producers-suite" },
  { to: "/headphones", label: "Headphones", testid: "nav-headphones" },
  { to: "/beatbox", label: "Beatbox", testid: "nav-beatbox" },
  { to: "/soundscape", label: "Soundscape", testid: "nav-soundscape" },
  { to: "/unknown-signals", label: "Unknown Signals", testid: "nav-unknown-signals" },
  { to: "/store", label: "Store", testid: "nav-store" },
];

export const Navbar = () => {
  const content = useSiteContent();
  const [open, setOpen] = useState(false);
  return (
    <nav
      data-testid="main-nav"
      className="sticky top-0 z-50 bg-[#0A0A0A]/85 backdrop-blur-md border-b border-[#27272A]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-4 flex items-center justify-between">
        <Link to="/" data-testid="nav-brand" className="group flex items-center gap-3">
          <div className="w-2 h-2 bg-neon shadow-[0_0_10px_#00FF6A]" />
          <div className="leading-none">
            <div className="font-display font-black text-[15px] tracking-tight">
              EFFORTLESS<span className="neon-text">.</span>METAPHOR
            </div>
            <div className="label-mono text-[10px] text-neutral-500 mt-1">
              {content.label.established} // OGTOMMYP
            </div>
          </div>
        </Link>

        <ul className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <li key={n.to}>
              <NavLink
                to={n.to}
                data-testid={n.testid}
                end={n.to === "/"}
                className={({ isActive }) =>
                  `label-mono transition-colors ${
                    isActive
                      ? "text-neon"
                      : "text-neutral-400 hover:text-neon"
                  }`
                }
              >
                {n.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-neon"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#27272A] bg-[#0A0A0A]">
          <ul className="px-6 py-4 flex flex-col gap-4">
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink
                  to={n.to}
                  data-testid={`${n.testid}-mobile`}
                  end={n.to === "/"}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `label-mono block ${
                      isActive ? "text-neon" : "text-neutral-400"
                    }`
                  }
                >
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
